
export default class Diagnosenbezeichnung {
    /** PK | erforderlich **/
    public diagnosebezeichnung_id: number | null = null;
    /** FK | erforderlich  **/
    public diagnose_id: number | null = null;
    /** max. 100 Zeichen | erforderlich **/
    public bezeichnung: string | null = null;
    /** max 1 Zeichen | j/n **/
    public gueltig: string | null = 'j';
    public impferinnerungstext: string | null = null;


    constructor(data?: Partial<Diagnosenbezeichnung>) {
        Object.assign(this, data);
    }
}
